import * as React from 'react'
import styled from 'styled-components'
import { Icon } from '../../UI/Icon'
import CustomLink from '../../CustomLink'
import { SbAsset } from '../../../types'

const IconWrapper = styled.span`
  align-items: center;
  // background: ${({ theme }) => theme.colors.black[7]};
  border-radius: 0.5rem;
  display: flex;
  height: 2rem;
  justify-content: center;
  transition: background-color 0.2s ease-in-out;
  width: 2rem;
`

const Wrapper = styled(CustomLink)`
  align-items: center;
  border-radius: 0.5rem;
  color: ${({ theme }) => theme.colors.black[1]};
  display: flex;
  gap: 0.5rem;
  outline: 0 solid transparent;
  padding: 0.5rem;
  text-decoration: none;
  transition: background-color 0.2s ease-in-out, outline 0.2s ease-in-out;
  user-select: none;

  &:hover {
    background-color: ${({ theme }) => theme.colors.black[6]};

    ${IconWrapper} {
      background-color: ${({ theme }) => theme.colors.white[1]};
    }
  }
`

const Label = styled.span`
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.1;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.black[1]};
`

const Subline = styled.span`
  color: ${({ theme }) => theme.colors.black[3]};
  display: block;
  font-size: 0.7rem;
  font-weight: 600;
  line-height: 1.1;
  margin-top: 0.3rem;
`

export interface GroupItemProps {
  label: string
  to: string
  subline?: string
  icon?: SbAsset
}

export const GroupItem = ({ label, to, icon, subline }: GroupItemProps) => {
  return (
    <Wrapper to={to}>
      {icon?.filename && (
        <IconWrapper>
          <Icon icon={icon} iconSize={"1.5rem"} />
        </IconWrapper>
      )}
      <div>
        <Label>{label}</Label>
        {subline && <Subline>{subline}</Subline>}
      </div>
    </Wrapper>
  )
}
